<template>
    <b-card no-body class="shadow-sm">
        <b-card-body>
            <h2 class="mb-4 text-center">Configuración de Diseño de la Empresa</h2>

            <b-form @submit.prevent="guardaDiseno">
                <b-row>
                    <b-col sm="4">
                        <b-form-group label-class="font-weight-bold" label="Color de FONDO para etiquetas">
                            <el-color-picker v-model="selectedDiseno.fondo" class="w-100 color-picker" />
                        </b-form-group>
                    </b-col>

                    <b-col sm="4">
                        <b-form-group label-class="font-weight-bold" label="Color de LETRA para etiquetas">
                            <el-color-picker v-model="selectedDiseno.letra" class="w-100 color-picker" />
                        </b-form-group>
                    </b-col>

                    <b-col sm="4" class="pb-3">
                        <b-form-group label-class="font-weight-bold" label="Vista previa">
                            <div class="rounded h-100 p-3 text-center" :style="estilo">
                                Texto de muestra que tendrá la etiqueta
                            </div>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-4">
                    <b-col md="3" v-for="(option, index) in radioOptions" :key="index">
                        <b-form-group :label="option.label" label-class="font-weight-bold">
                            <b-form-radio-group :id="option.id" :name="option.id" v-model="selectedDiseno[option.model]"
                                :options="opciones" buttons button-variant="outline-primary" />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-4">
                    <b-col sm="6">
                        <b-form-group label="Seleccionar Formato de Etiquetas" label-class="font-weight-bold">
                            <el-select v-model="selectedDiseno.formatos_etiquetas_seleccionados"
                                placeholder="Seleccionar formatos de la etiqueta" size="small" filterable multiple
                                class="w-100">
                                <el-option v-for="optformato in optformatos" :key="optformato.value"
                                    :label="optformato.text" :value="optformato.value" />
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col sm="6">
                        <b-form-group label="Seleccionar Lista de Chequeo usada para el dashboard"
                            label-class="font-weight-bold">
                            <el-select v-model="selectedChecklist" placeholder="Seleccionar Lista de Chequeo"
                                size="small" filterable class="w-100" @change="onChecklistChange">
                                <el-option v-for="item in tipoListaChequeo" :key="item.id" :label="item.tipo_lista"
                                    :value="item.id" />
                            </el-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-4">
                    <b-col class="d-flex justify-content-between">
                        <b-button @click="backRoute()" size="sm" variant="outline-secondary">
                            <i class="fa fa-reply fa-lg mr-2"></i>
                            Volver
                        </b-button>

                        <b-button variant="primary" v-if="validarPermisoComponente('empresa-editar-diseño')" class="btn-sm" type="submit"
                            :disabled="!selectedDiseno.formatos_etiquetas_seleccionados.length">
                            <i class="fa fa-save mr-2"></i>
                            Guardar
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { Photoshop, Chrome, Material } from 'vue-color';
import { ColorPicker } from 'element-ui';
import { validarPermisoComponente } from "@/plugins/acl";
export default {
    name: 'empresa-diseno',
    components: {
        Photoshop,
        Chrome,
        Material,
        ColorPicker,
    },
    data() {
        return {
            color: '#303030',
            opciones: [
                { text: 'Si', value: 1 },
                { text: 'No', value: 0 },
            ],
            selectedChecklist: null,
            radioOptions: [
                { id: 'qr', model: 'qr', label: 'Habilitar QR para etiquetas' },
                { id: 'etiqueta_mini', model: 'etiqueta_mini', label: 'Habilitar Etiqueta Mini' },
                { id: 'etiqueta_resolucion', model: 'etiqueta_resolucion', label: 'Habilitar Etiquetas Resolución 0773' },
                { id: 'etiqueta_vertical', model: 'etiqueta_vertical', label: 'Habilitar Etiquetas Verticales' },
            ],
            validarPermisoComponente: validarPermisoComponente,
        };
    },
    async mounted() {
        await this.getDiseno({ id: this.$route.params.id });
        await this.listarTipoListaChequeo(this.$route.params.id);
    },
    computed: {
        ...mapState('empresa', ['selectedDiseno', 'optformatos']),
        ...mapState('listaChequeo', ['tipoListaChequeo']),
        estilo() {
            return {
                color: this.selectedDiseno.letra,
                backgroundColor: this.selectedDiseno.fondo,
            };
        },
        checklistOptions() {
            return this.tipoListaChequeo.map(item => ({
                value: item.id,
                text: item.tipo_lista,
            }));
        },
    },
    methods: {
        ...mapActions('empresa', ['guardaDiseno', 'getDiseno', 'setChecklistCompany']),
        ...mapMutations('empresa', ['resetDiseno']),
        ...mapActions('listaChequeo', ['listarTipoListaChequeo']),
        onChange(val) {
            this.colors = val;
        },
        async onChecklistChange(value) {
            if (value) {
                await this.setChecklistCompany({
                    company_id: this.$route.params.id,
                    check_list_id: value,
                });

                await this.listarTipoListaChequeo(this.$route.params.id);
            }
        },
        backRoute(){
        const currentPath = this.$route.path;
        if (currentPath.includes("/my-company")) {
            this.$router.go(-1);
        }else {
            this.$router.push("/empresas");
        }
    },
    },

    watch: {
        tipoListaChequeo: {
            handler: function (val) {
                if (val.length) {
                    const selectedChecklistFind = val.find(item => item.tipo_lista_chequeo_empresa && item.tipo_lista_chequeo_empresa.use_for_dashboard === 1);
                    this.selectedChecklist = selectedChecklistFind ? selectedChecklistFind.id : null;
                }
            },
            immediate: true,
        },
    },

};
</script>

<style scoped>
.color-picker .el-color-picker__trigger {
    width: 100%;
}

.card-body {
    background-color: #f8f9fa;
}

.form-group label {
    margin-bottom: 0.5rem;
}

.btn-sm {
    padding: 0.375rem 0.75rem;
}
</style>
